import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionService } from 'src/app/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AwsCompanyMyAccountService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'client-id': 'apliclientesksks',
      'client-hash': 'apliclientesksks',
      Auth: this.sessionService.token,
    }),
  };

  getCompanyPreference(body){
    return this.http.post(`${environment.baseUrlAPI}/user/getCompanyPreference`, body , this.httpOptions);
  }

  updateCompanyPreferencePolicies(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateCompanyPreferencePolicies`, body , this.httpOptions);
  }

  updateCompanyPreferenceBudget(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateCompanyPreferenceBudget`, body , this.httpOptions);
  }

  updateCompanyHistoryExchange(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateCompanyHistoryExchange`, body , this.httpOptions);
  }

  updateCompanyPreferenceShoppingFiles(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateCompanyPreferenceShoppingFiles`, body , this.httpOptions);
  }

  updatePreferenceCompanyShoppingPlan(body){
    return this.http.post(`${environment.baseUrlAPI}/company/updatePreferenceCompanyShoppingPlan`, body , this.httpOptions);
  }

  preferenceCompanyShoppingPlan(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceCompanyShoppingPlan/save`, body , this.httpOptions);
  }

  usersFilterCompanyShippingRequest(body){
    return this.http.post(`${environment.baseUrlAPI}/company/usersFilterCompanyShippingRequest`, body , this.httpOptions);
  }

  updateCompanyPreferenceSendingAlertsEvaluation(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateCompanyPreferenceSendingAlertsEvaluation`, body , this.httpOptions);
  }

  remindersExpiration(body){
    return this.http.post(`${environment.baseUrlAPI}/company/contract/remindersExpiration/update`, body , this.httpOptions);
  }

  preferenceShoppingPlan(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceShoppingPlan/update`, body , this.httpOptions);
  }

  preferenceAcceptedPolicies(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceAcceptedPolicies/update`, body , this.httpOptions);
  }

  updatePreferenceRequirementsApprovals(body){
    return this.http.post(`${environment.baseUrlAPI}/company/updatePreferenceRequirementsApprovals`, body , this.httpOptions);
  }
  
  listCheckList(body){
    return this.http.post(`${environment.baseUrlAPI}/company/documentChecklist`, body , this.httpOptions);
  }

  createCheckList(body){
    return this.http.post(`${environment.baseUrlAPI}/company/documentChecklist/create`, body , this.httpOptions);
  }

  deleteCheckList(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/company/documentChecklist/delete` , httpOptionsTemp);
  }

  updateCheckList(body){
    return this.http.put(`${environment.baseUrlAPI}/company/documentChecklist/update`, body , this.httpOptions);
  }

  preferenceRequiredDocumentsSave(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceRequiredDocuments/save`, body , this.httpOptions);
  }

  preferenceRequiredDocumentsList(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceRequiredDocuments/list`, body , this.httpOptions);
  }

  preferenceSupplierApprovalsUpdate(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceSupplierApprovals/update`, body , this.httpOptions);
  }

  preferenceTimeZoneUpdate(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceTimeZone/update`, body , this.httpOptions);
  }

  preferenceDirectPurchasesUpdate(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceDirectPurchases/update`, body , this.httpOptions);
  }

  preferencePercentageSuppliersUpdate(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferencePercentageSuppliers/update`, body , this.httpOptions);
  }

  preferenceNotifyBankAccountsSave(body){
    return this.http.post(`${environment.baseUrlAPI}/company/preferenceNotifyBankAccounts/save`, body , this.httpOptions);
  }

  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    }),
  };

  getEvaluationSuppliers(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/getEvaluationSuppliers`, body, this.httpOptionsNew);
  }

  saveEvaluationSuppliers(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/saveEvaluationSuppliers`, body, this.httpOptionsNew);
  }

  getPositionsTemplateEvaluation(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/getPositionsTemplateEvaluation`, body, this.httpOptionsNew);
  }

  saveTemplateEvaluation(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/saveTemplateEvaluation`, body, this.httpOptionsNew);
  }

  deleteTemplateEvaluation(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/company/my-account/deleteTemplateEvaluation`, httpOptionsTemp);
  }

  detailPreferencePurchaseOrder(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/preference/purchaseOrder`, body, this.httpOptionsNew);
  }

  updatePreferencePurchaseOrder(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/my-account/preference/purchaseOrder`, body, this.httpOptionsNew);
  }

  detailPreferenceConformity(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/preference/conformity`, body, this.httpOptionsNew);
  }

  updatePreferenceConformity(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/my-account/preference/conformity`, body, this.httpOptionsNew);
  }

  detailPreferenceInvoiceReceived(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/preference/invoiceReceived`, body, this.httpOptionsNew);
  }

  updatePreferenceInvoiceReceived(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/my-account/preference/invoiceReceived`, body, this.httpOptionsNew);
  }

  // v5
  preferenceNotConformityDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/preference/notConformity`, body, this.httpOptionsNew);
  }

  preferenceNotConformitySave(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/my-account/preference/notConformity`, body, this.httpOptionsNew);
  }

  //

  preferenceQuotesWaytopay(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/preference/quotes/waytopay`, body, this.httpOptionsNew);
  }
  
  updatePreferenceQuotesWaytopay(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/my-account/preference/quotes/waytopay`, body, this.httpOptionsNew);
  }

  sortTemplateEvaluation(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/my-account/sortTemplateEvaluation`, body, this.httpOptionsNew);
  }
}
